import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { responsiveStyles } from "../../utils/responsiveStyles.mjs.mjs";
import { mapStyle } from "../../utils/mapStyle.mjs.mjs";
import { injectSpacing, injectInsetSpacing, mapSpaceToVar, } from "../../api/spacing/injectSpacing.mjs.mjs";
import { AlignMap, DirectionMap, JustifyMap, WrapMap, } from "./Layout.types.mjs.mjs";
export const StyledLayout = styled.div.withConfig({ displayName: "auir-41e20d9-StyledLayout", componentId: "auir-41e20d9-1qr6qws" }) `
  display: flex;
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  column-gap: ${(props) => mapSpaceToVar(props.theme.responsive.spacing, props.columnGap)};
  row-gap: ${(props) => mapSpaceToVar(props.theme.responsive.spacing, props.rowGap)};
  ${(props) => responsiveStyles({
    'align-items': mapStyle(props.align, AlignMap),
    'flex-direction': mapStyle(props.direction, DirectionMap),
    'justify-content': mapStyle(props.justify, JustifyMap),
    'flex-wrap': mapStyle(props.wrap, WrapMap),
}, props.theme.breakpoints)}
  ${injectSpacing('margin')}
  ${injectInsetSpacing('padding')}
`;
//# sourceMappingURL=Layout.styles.mjs.mjs.map